import { useSeller } from "@/hooks/useAccount";
import { getGiftDetailsRequirements, getRecipientRules } from "@/models/GiftPreference";
import { isGift } from "@/models/Purchase";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

export const useGiftDetailsRequirements = () => getGiftDetailsRequirements(useSeller().preferences.gift);

export const useRecipientRules = () => {
    const { recipientDetailsRequirement } = useGiftDetailsRequirements();
    const isScannedGiftCard = useCreatePurchaseStore((state) => state.getActiveItem()?.isScannedGiftCard);
    const isRecipientSkipped = useCreatePurchaseStore((state) => state.getActiveItem()?.isRecipientSkipped);

    return getRecipientRules(recipientDetailsRequirement, { isScannedGiftCard, isRecipientSkipped });
};

// Mixed carts keep the Settings > Purchases email rule; only gift-only carts let the gift setting override it.
export const useGiftOnlyOrganizerRequirement = () => {
    const { organizerDetailsRequirement } = useGiftDetailsRequirements();
    const isGiftOnlyCart = useCreatePurchaseStore((state) => state.purchase.items.every((item) => isGift(item)));

    return isGiftOnlyCart ? organizerDetailsRequirement : null;
};
